import axios from 'core/common/config/axios-config';
import {Address, Party, PartyRole} from "party/partyDomain";
import {DataObjectDto, IDomainObject} from "core/form/formUtils";
import {observable} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";
import {PartyActivity} from "core/event/eventDomain";
import {PartyCreditEntry, PartyCreditEntryDto} from "accounting/accountingDomain";


class PartyService  {


  @observable public partyObject: Party;


  readParty(partyId: number): Promise<Party> {
    return axios.get('/party/' + partyId)
      .then(response => new Party(response.data));
  }

  searchParty(email: string): Promise<Party[]> {
    return axios.get('/party/party-search', {params: {email}})
      .then(response => response.data.map(json => new Party(json)));
  }

  /**
   * spec :  {ico: 456456}, {birthNumber: 346456456}, {ico: 456456, birthNumber: 346456456}
   * @param spec
   * @returns {*}
     */
  partyExist(spec: {partyId?: number, ico?: string, birthNumber?: string}): Promise<boolean> {
    return axios.get('/party/party-exist', {params:spec})
      .then(response => response.data);
  }

  partyVatIdExist(spec: {vatId: string, nationality: string}): Promise<boolean> {
    return axios.get('/party/party-vatid-exist', {params:spec})
      .then(response => response.data);
  }

  partyVatIdDownload(spec: {vatId: string, nationality: string, language: string}): Promise<IDomainObject> {
    return axios.get('/party/party-vatid-download', {params:spec})
      .then(response => response.data);
  }

  partyIdExist(spec: {id: string}): Promise<boolean> {
    return axios.get('/party/party-id-exist', {params:spec})
      .then(response => response.data);
  }

  partyIdDownload(spec: {id: string}): Promise<IDomainObject> {
    return axios.get('/party/party-id-download', {params:spec})
      .then(response => response.data);
  }

  addressParse(spec: {addressLine: string, nationality: string, language: string}): Promise<IDomainObject> {
    return axios.get('/party/address-parse', {params:spec})
      .then(response => response.data);
  }


  partySave(partyDto: DataObjectDto<Party>): Promise<IDomainObject> {
    console.log('partySave %O', partyDto);
    return axios.post('/party', partyDto, {showPrettyError: true})
    .then((response) => response.data);
  }

  deleteParty(partyId: number): Promise<any> {
    return axios.delete('/party/' + partyId, {showPrettyError: true});
  }

  manualCustomerRegistration(partyId: number): Promise<PartyActivity[]> {
    return axios.post('/party/customer-registration/' + partyId, null, {showPrettyError: true})
      .then((response) => response.data.map(json => new PartyActivity(json)));
  }


  public newRole(roleType: number): PartyRole {
    return new PartyRole( {roleType: mdEntityService.getEntity('PartyRoleType').getLovItem(roleType)} );
  }

  viberUserCheck(spec: {id: string}): Promise<boolean> {
    return axios.get("/viber/user-check", {params:spec})
      .then((response) => response.data);
  }

  getViberBotUrl() {
    return axios.get("/viber/bot-url")
      .then((response) => response.data);
  }


  // ////////// PARTY CREDIT ENTRIES ////////////////////////////////////////////////////////////////////////////////

  readCreditEntries(partyId: number): Promise<PartyCreditEntryDto> {
    return axios.get('/party/credit-entry', {params: {partyId}})
      .then(response => ({entries: response.data.entries.map(json => new PartyCreditEntry(json)), sums: response.data.sums}));
  }




}

export default new PartyService();




// WEBPACK FOOTER //
// ./src/party/partyService.ts